import { render, staticRenderFns } from "./approve-pr-modal.vue?vue&type=template&id=55b4f352&"
import script from "./approve-pr-modal.vue?vue&type=script&lang=js&"
export * from "./approve-pr-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports